module.exports = __webpack_public_path__ + "img/mike-mccain-adventure-bound.bd8ff47.jpg";